<template>
    <div class="flow-wrap">
        <div class="info-tab">
            <div class="info-wrap">
                <div class="title">
                    <div class="name">定位交底</div>
                    <div class="num">FWD202202300001</div>
                </div>
                <div class="date">施工时间：2022.2.22 2022.3.31</div>
                <img class="state-img" src="@/assets/images/archives/completed.png" alt="">
            </div>
            <div class="tab-wrap">
                <template v-for="(item,index) in arrTab">
                    <div class="tab-item" :class="{'tab-item-active':index==nTabCurrent}" @click="tabChange(index)">{{item}}</div>
                </template>
            </div>
        </div>
        <div class="content-info">
            <transition-group name="hello" appear>
                <div class="tab-content" v-show="nTabCurrent==0" key="0">
                    <div class="basic-content">
                        <template v-for="item in arrBasicInfo">
                            <div class="item">
                                <div class="title-wrap">
                                    <div class="title">{{item.title}}</div>
                                </div>
                                <div class="data-wrap">
                                    <template v-for="(it,itx) in item.arr">
                                        <div class="lable-wrap" :style="{'background':(itx%2)?'#ffffff':'#F9F9FB'}">
                                            <div class="lable">{{it.name}}：</div>
                                            <div class="value">{{it.value===''?'暂无信息':it.value}}</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tab-content" v-show="nTabCurrent==1" key="1">
                    <div class="basic-content">
                        <template v-for="item in arrProcess">
                            <div class="item">
                                <div class="title-wrap">
                                    <div class="title">{{item.title}}</div>
                                </div>
                                <div class="data-wrap" v-if="item.type == 0">
                                    <template v-for="(it,itx) in item.arr">
                                        <div class="lable-wrap" :style="{'background':(itx%2)?'#ffffff':'#F9F9FB'}">
                                            <div class="lable">{{it.name}}：</div>
                                            <div class="value">{{it.value===''?'暂无信息':it.value}}</div>
                                        </div>
                                    </template>
                                </div>
                                <template v-for="sumitem in item.arrImg">
                                    <div class="data-wrap" v-if="item.type == 1">
                                        <div class="location-title">
                                            {{sumitem.name}}
                                        </div>
                                        <div class="location-img">
                                            <template v-for="img in sumitem.locationImg">
                                                <div class="img-item"></div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tab-content" v-show="nTabCurrent==2" key="2">
                    <div class="attendance-content">
                        <div class="title-wrap">
                            <div class="title">审批记录</div>
                        </div>
                        <div class="record-wrap">
                            <template v-for="(item,index) in arrRecord">
                                <div class="record-item">
                                    <div class="record-day">
                                        <div class="day-top">
                                            <div class="day-left">
                                                <img src="@/assets/images/archives/workOrder/time-icon.png" alt="">
                                            </div>
                                            <div class="day-right">{{item.day}}</div>
                                        </div>
                                        <div class="day-bottom"><p></p></div>
                                    </div>
                                    <template v-for="(it,itx) in item.arrDate">
                                        <div class="resord-date">
                                            <div class="date-top">
                                                <div class="date-left">{{it.date}}</div>
                                                <div class="date-right">{{it.title}}</div>
                                            </div>
                                            <div class="date-bottom">
                                                <div class="line-left"><p v-if="!((index==arrRecord.length-1)&&(itx==item.arrDate.length-1))"></p></div>
                                                <div class="text">
                                                    <div class="text-content">{{it.address}}</div>
                                                    <div class="img-wrap">
                                                        <template v-for="img in it.img">
                                                            <div class="img-item"></div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            isSupervision:true,//是否是监理验收
            nTabCurrent:0,
            arrTab:['基本信息','过程反馈','考勤记录'],
            arrBasicInfo:[
                {
                    title:'基本信息',
                    arr:[
                        {name:'工单号',value:'PWF8069689698975'},
                        {name:'工单内容',value:''},
                        {name:'客户',value:'龚秀娟'},
                        {name:'预约时间',value:'2021-11-23 21:22:21'},
                        {name:'改约时间',value:''},
                        {name:'完工时间',value:'2021-11-25 21:22:21'},
                        {name:'工序负责人：',value:'年付伟'},
                        {name:'服务队：',value:'南京艺宁城北服务部'},
                        {name:'房屋类型：',value:'复式'},
                        {name:'建筑面积：',value:'148'},
                        {name:'房屋整体保温：',value:''},
                        {name:'层高：',value:'0'},
                        {name:'使用习惯：',value:''},
                        {name:'特别要求：',value:''},
                    ]
                },
                {
                    title:'收款信息',
                    arr:[
                        {name:'实收金额',value:0},
                        {name:'减免金额',value:0},
                        {name:'材料费合计',value:0},
                        {name:'其他费用',value:0},
                    ]
                }
            ],
            arrProcess:[
                {
                    title:'锅炉定位及预留要求',
                    type:0,
                    arr:[
                        {name:'燃气气源确认：',value:'天然气'},
                        {name:'燃气表规格：',value:'满足'},
                        {name:'锅炉安装空间最小尺寸：',value:''},
                    ]
                },
                {
                    title:'分集水器定位及预留要求',
                    type:0,
                    arr:[
                        {name:'分集水器位置：',value:''},
                        {name:'分集水器安装方式：',value:'出墙式'},
                        {name:'分集水器安装位置：',value:'符合要求'},
                    ]
                },
                {
                    title:'预计',
                    type:0,
                    arr:[
                        {name:'装修开工时间：',value:'2022-03-22'},
                        {name:'水电完成时间：',value:'2022-04-22'},
                        {name:'采暖系统施工时间：',value:'2022-05-22'},
                    ]
                },
                {
                    title:'空调设备定位',
                    type:1,
                    arrImg:[
                        {
                            name:'现场定位末端风盘位置',
                            locationImg:[
                                require('@/assets/images/case/case_lore.png'),
                                require('@/assets/images/case/case_lore.png'),
                            ]
                        },
                        {
                            name:'现场定位主管道过墙孔位置',
                            locationImg:[
                                require('@/assets/images/case/case_lore.png'),
                                require('@/assets/images/case/case_lore.png'),
                            ]
                        },
                        {
                            name:'现场定位中控器电源位置',
                            locationImg:[
                                require('@/assets/images/case/case_lore.png'),
                                require('@/assets/images/case/case_lore.png'),
                            ]
                        }
                    ],
                }
            ],
            arrRecord:[
                {
                    day:"2022-06-23 星期四",
                    arrDate:[
                        {
                            date:'08:22',
                            title:'签退',
                            address:'江苏省南京市栖霞区文苑路9号',
                            img:[
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                            ]
                        },
                        {
                            date:'18:22',
                            title:'签到',
                            address:'江苏省南京市栖霞区文苑路9号',
                            img:[
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                            ]
                        }
                    ]
                },
                {
                    day:"2022-06-22 星期三",
                    arrDate:[
                        {
                            date:'08:40',
                            title:'签退',
                            address:'江苏省南京市栖霞区文苑路9号',
                            img:[
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                                {url:require('@/assets/images/case/case_lore.png')},
                            ]
                        },
                        {
                            date:'18:40',
                            title:'签到',
                            address:'江苏省南京市栖霞区文苑路9号',
                            img:[]
                        }
                    ]
                }
            ]
        }
    },
    methods:{
        // 切换标签
        tabChange(index){
            this.nTabCurrent=index
        },
    }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar{display:none}
/* 进入的起点、离开的终点 */
.hello-enter,
.hello-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}
.hello-enter-active,
.hello-leave-active {
    transition: 0.4s linear;
}
/* 进入的终点、离开的起点 */
.hello-enter-to,
.hello-leave {
    opacity: 1;
    transform: translateX(0);
}
.flow-wrap{
    width: 100vw;
    height: 100vh;
    background: #F9F9FB;
    display: flex;
    flex-direction:column;
    .info-tab{
        padding: 38px 32px 16px 32px;
        //margin-bottom: 16px;
        background: #F3F6FF;
        .info-wrap{
            position: relative;
            .title{
                display: flex;
                align-items: center;
                .name{
                    font-size: 36px;
                    font-weight: 600;
                    color: #333333;
                    line-height: 42px;
                }
                .num{
                    font-size: 24px;
                    font-weight: 400;
                    color: #555555;
                    line-height: 28px;
                    margin-left: 16px;
                }

            }
            .date{
                font-size: 24px;
                font-weight: 400;
                color: #555555;
                margin-top: 16px;
                line-height: 28px;
            }
            .state-img{
                position: absolute;
                top: 0px;
                right:0px;
                width: 161px;
                height: 153px;
            }
        }
        .tab-wrap{
            width: 100%;
            height: 80px;
            background: #FFFFFF;
            border-radius: 16px 16px 16px 16px;
            margin-top: 84px;
            display: flex;
            padding: 0 88px;
            justify-content: space-between;
            .tab-item{
                font-size: 24px;
                font-weight: 400;
                color: #A3A3A3;
                line-height: 80px;
            }
            .tab-item-active{
                font-weight: 600;
                color: #0D53FC;
                position: relative;
                &:after{
                    width: 100%;
                    height: 4px;
                    content:'';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background:#0D53FC;
                }
            }
        }
    }
    .content-info{
        width: 100%;
        flex: 1;
        padding: 0px 32px 32px 32px;
        overflow-y: scroll;
        background:linear-gradient(to bottom,#F3F6FF 0%,#F3F6FF 10%,#F9F9FB 10.01%,#F9F9FB 100%);
        .tab-content{
            width: 100%;
            .basic-content{
                width: 100%;
                .item{
                    margin-bottom: 16px;
                    width: 100%;
                    background: #FFFFFF;
                    border-radius: 16px 16px 16px 16px;
                    overflow: hidden;
                    .title-wrap{
                        padding: 32px 44px;
                        .title {
                            font-size: 24px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 28px;
                            border-left: 5px solid #0D53FC;
                            padding-left: 16px;
                        }
                    }
                    .data-wrap{
                        .lable-wrap{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width:100%;
                            height: 80px;
                            background: #F9F9FB;
                            padding: 0 48px;
                            .lable{
                                font-size: 24px;
                                color: #999999;
                            }
                            .value{
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                            }
                        }
                        .location-title{
                            padding-left: 52px;
                            box-sizing: border-box;
                            font-size: 24px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 28px;
                        }
                        .location-img{
                            padding-left: 52px;
                            box-sizing: border-box;
                            display: flex;
                            flex-wrap: wrap;
                            margin-top: 32px;
                            margin-bottom: 32px;
                            .img-item{
                                width: 160px;
                                height: 160px;
                                background: #F9F9FB;
                                border-radius: 16px;
                                margin-right: 12px;
                                margin-bottom: 12px;
                                &:nth-child(3n){
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                }
            }
            .supervision-content{
                .item{
                    width: 100%;
                    border-radius: 16px;
                    background: #ffffff;
                    padding: 48px 44px;
                    margin-bottom: 16px;
                    .title {
                            font-size: 28px;
                            font-weight: 600;
                            color: #333333;
                            line-height: 33px;
                    }
                    .step-wrap{
                        margin-top: 32px;
                        .step-item{
                            padding-bottom: 64px;
                            border-bottom: 2px solid #F5F5F5;
                            margin-bottom: 48px;
                            &:last-child{
                                margin-bottom: 0;
                                border-bottom:0;
                                padding-bottom:0;
                            }
                            .title-wrap{
                                .title {
                                    font-size: 24px;
                                    color: #333333;
                                    line-height: 28px;
                                    border-left: 5px solid #0D53FC;
                                    padding-left: 16px;
                                }
                            }
                            .desc{
                                font-size: 24px;
                                font-weight: 400;
                                color: #999999;
                                line-height: 28px;
                                margin:20px 0 16px 0;
                            }
                            .tips{
                                font-size: 20px;
                                font-weight: 500;
                                color: #E95859;
                                line-height: 23px;
                                text-indent: 10px;
                            }
                            .standard{
                                background: #F9F9FB;
                                border-radius: 16px;
                                overflow: hidden;
                                margin-top: 32px;
                                .title{
                                    width: 100%;
                                    height: 64px;
                                    background: linear-gradient(126deg, rgba(13, 83, 252, 0.5) 0%, rgba(13,83,252,0) 100%);
                                    padding-left: 20px;
                                    line-height: 64px;
                                    font-size: 24px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }
                                .img-wrap{
                                    overflow: hidden;
                                    width: 100%;
                                    height: 274px;
                                    background: #F9F9FB;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                            }
                            .live{
                                overflow-x: scroll;
                                margin-top: 16px;
                                white-space: nowrap;
                                .live-img{
                                    display: inline-block;
                                    width: 160px;
                                    height: 160px;
                                    background: #F9F9FB;
                                    border-radius: 16px;
                                    margin-right: 16px;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                            }
                            .question{
                                margin-top: 64px;
                                .question-item{
                                    margin-bottom: 54px;
                                    &:last-child{
                                        margin-bottom: 0;
                                    }
                                    .title{
                                        font-size: 24px;
                                        font-weight: 400;
                                        color: #999999;
                                        margin-bottom: 22px;
                                        line-height: 28px;
                                    }
                                    .answer-wrap{
                                        display: flex;
                                        p{
                                            width: 30%;
                                            font-size: 24px;
                                            font-weight: 400;
                                            color: #999999;
                                            line-height: 28px;
                                            display: flex;
                                            align-items: center;
                                            img{
                                                width: 32px;
                                                height: 32px;
                                            }
                                        }
                                        .active-p{
                                            color: #000000;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .worker-content{
                .item{
                    width: 100%;
                    height: 338px;
                    background: #FFFFFF;
                    border-radius: 16px;
                    padding: 32px 44px;
                    margin-bottom: 16px;
                    .title-wrap{
                        .title {
                            font-size: 24px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 28px;
                            border-left: 5px solid #0D53FC;
                            padding-left: 16px;
                        }
                        .live{
                            margin-top: 48px;
                            overflow-x: scroll;
                            white-space: nowrap;
                            .live-img{
                                display: inline-block;
                                width: 160px;
                                height: 160px;
                                background: #F9F9FB;
                                border-radius: 16px;
                                margin-right: 16px;
                                img{
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }
                        }
                    }
                }
            }
            .attendance-content{
                width: 100%;
                background: #FFFFFF;
                border-radius: 16px;
                padding: 32px 44px;
                .title-wrap{
                    margin-bottom: 66px;
                    .title {
                        font-size: 24px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 28px;
                        border-left: 5px solid #0D53FC;
                        padding-left: 16px;
                    }
                }
                .record-wrap{
                    .record-item{
                        .record-day{
                            .day-top{
                                display: flex;
                                align-items: center;
                                .day-left{
                                    width: 64px;
                                    img{
                                        width: 64px;
                                        height: 64px;
                                    }
                                }
                                .day-right{
                                    padding-left: 30px;
                                    font-size: 28px;
                                    font-weight: 600;
                                    color: #333333;
                                }
                            }
                            .day-bottom{
                                width: 64px;
                                height: 80px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                p{
                                    width: 0px;
                                    height: 100%;
                                    border-left: 1px dashed #EEEEEE;
                                }
                            }
                        }
                        .resord-date{
                            .date-top{
                                display: flex;
                                align-items: center;
                                .date-left{
                                    width: 64px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000000;
                                }
                                .date-right{
                                    padding-left: 30px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000000;
                                }
                            }
                            .date-bottom{
                                display: flex;
                                .line-left{
                                    width: 64px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    p{
                                        width: 0px;
                                        height: 100%;
                                        border-left: 1px dashed #EEEEEE;
                                    }
                                }
                                .text{
                                    flex: 1;
                                    font-size: 24px;
                                    font-weight: 400;
                                    padding-left: 30px;
                                    color: #999999;
                                    padding-bottom: 50px;
                                }
                                .text-content{
                                    margin-top: 10px;
                                }
                                .img-wrap{
                                    display: flex;
                                    flex-wrap: wrap;
                                    margin-top: 16px;
                                    .img-item{
                                        width: 160px;
                                        height: 160px;
                                        background: #F9F9FB;
                                        border-radius: 16px;
                                        margin-right: 12px;
                                        margin-bottom: 12px;
                                        &:nth-child(3n){
                                            margin-right: 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
